import React from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import { getCodeColor } from "../components";


export const GeneratePdfReporteVentas = ({ pdfData, canViewCostoBeneficio, themeColor, convertPrice = (() => { }) }) => {
	const themeConverted = getCodeColor(themeColor);

	const styles = StyleSheet.create({
		page: {
			flexDirection: "column",
			padding: 10,
			fontSize: 10,
			fontFamily: "Helvetica",
			position: "relative",
		},
		headerContainer: {
			flexDirection: "row",
			alignContent: "center",
			paddingBottom: 10,
		},
		headerLeft: {
			flexDirection: "column",
			width: "40%",
			lineHeight: 1.2,
			fontSize: 7,
		},
		logo: {
			width: 150,
			height: 100,
		},
		titleBig: {
			fontFamily: "Helvetica-Bold",
			fontSize: 19,
			letterSpacing: 1,
			margin: 0,
			paddingLeft: 35,
			position: "relative",
			top: "15",
			right: "40",
		},
		subHeaderContainer: {
			flexDirection: "row",
			justifyContent: "space-between",
			paddingRight: "10",
			alignItems: "center",
			position: "relative",
			bottom: 5,
			fontSize: 9,
		},
		tableContainer: {
			width: "100%",
			marginVertical: 10,
			position: "relative",
			bottom: 10,
		},
		tableHeader: {
			flexDirection: "row",
			backgroundColor: themeConverted,
			color: "#fff",
		},
		tableHeaderCell: {
			padding: 5,
			fontWeight: "bold",
			textAlign: "center",
			fontSize: 8,
			color: "white",
		},
		tableRow: {
			flexDirection: "row",
			borderBottomWidth: 1,
			borderBottomColor: "#dddddd",
			borderBottomStyle: "solid",
		},
		tableCell: {
			padding: 5,
			textAlign: "center",
			fontSize: 8,
		},
		tableCellNo: { flex: 0.5 },
		tableCellDate: { flex: 0.8 },
		tableCellClient: { flex: 1.5, textAlign: "left" },
		tableCellCode: { flex: 1 },
		tableCellProduct: { flex: 2, textAlign: "left" },
		tableCellQuantity: { flex: 0.6 },
		tableCellCost: { flex: 0.8 },
		tableCellBenefit: { flex: 0.8 },
		tableCellPrice: { flex: 0.8 },

		tableRowTotal: {
			flexDirection: "row",
			backgroundColor: themeConverted,
			color: "#fff",
			fontWeight: "bold",
		},
		totalCell: {
			padding: 5,
			textAlign: "center",
			fontSize: 8,
			color: "#fff",
			fontWeight: "bold",
		},
		signatureContainer: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-around",
			marginTop: 30,
		},
		signatureLine: {
			marginBottom: 5,
		},
		signatureBox: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
		pageNumbers: {
			position: "absolute",
			bottom: 20,
			right: 20,
			textAlign: "right",
		},
	});
	// Calculate totals
	const totalQuantity = pdfData.details.reduce((acc, item) => acc + item.qp, 0);
	const totalCost = pdfData.details.reduce((acc, item) => acc + parseFloat(item.pPurchase || 0) * item.qp, 0);
	const totalSale = pdfData.details.reduce((acc, item) => acc + parseFloat(item.pSale || 0) * item.qp, 0);
	const totalBenefit = totalSale - totalCost;
	const apiUrl = process.env.REACT_APP_API_URL;
	return (
		<Document>
			<Page size="A4" style={styles.page}>
				{/* Header */}
				<View style={styles.headerContainer}>
					<View style={styles.headerLeft}>
						<View style={{ position: "relative" }}>
							<Image
								source={`${apiUrl}${pdfData.logo}`}
								src={`${apiUrl}${pdfData.logo}`}
								style={styles.logo}
							/>
						</View>
						<View>
							<Text>Empresa: {pdfData.cName}</Text>
							<Text>Dirección: {pdfData.address}</Text>
							<View style={{ flexDirection: "row", marginTop: "2px" }}>
								<Text>NIT: {pdfData.cNit}</Text>
								<Text style={{ paddingLeft: 15 }}>Tel: {pdfData.phone}</Text>
							</View>
						</View>
					</View>
					<View style={{ justifyContent: "center", alignItems: "center" }}>
						<Text style={styles.titleBig}>REPORTE DE VENTAS</Text>
					</View>
				</View>

				{/* Sub-header */}
				<View style={styles.subHeaderContainer}>
					<View>
						<Text>
							Caja: {pdfData.cashier_name}{/*Tel: {pdfData.cashier_phone} */}
						</Text>
					</View>
					<View style={{ display: "flex", flexDirection: "row", gap: "5", position: "relative", bottom: 0 }}>
						<Text>Fecha: {pdfData.oDate}</Text>
						<Text style={{ fontSize: 7, position: "relative", top: "1.5" }}>{pdfData.oTime}</Text>
					</View>
				</View>

				{/* Table */}
				<View style={styles.tableContainer}>
					{/* Table Header */}
					<View style={styles.tableHeader}>
						<Text style={[styles.tableHeaderCell, styles.tableCellNo]}>No</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellDate]}>Fecha</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellClient]}>Cliente</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellCode]}>Código</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellProduct]}>Producto</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellQuantity]}>Cant</Text>
						{canViewCostoBeneficio && (
							<>
								<Text style={[styles.tableHeaderCell, styles.tableCellCost]}>Costo</Text>
								<Text style={[styles.tableHeaderCell, styles.tableCellBenefit]}>Beneficio</Text>
							</>
						)}
						<Text style={[styles.tableHeaderCell, styles.tableCellPrice]}>Precio</Text>
					</View>

					{/* Table Rows */}
					{pdfData.details.map((item, index) => {
						const sale = parseFloat(item.pSale || 0);
						const purchase = parseFloat(item.pPurchase || 0);
						const quantity = item.qp;
						const benefit = (sale - purchase) * quantity;

						return (
							<View style={styles.tableRow} key={index}>
								<Text style={[styles.tableCell, styles.tableCellNo]}>{index + 1}</Text>
								<Text style={[styles.tableCell, styles.tableCellDate]}>{item.dDate}</Text>
								<Text style={[styles.tableCell, styles.tableCellClient]}>{item.client_name}</Text>
								<Text style={[styles.tableCell, styles.tableCellCode]}>{item.code}</Text>
								<Text style={[styles.tableCell, styles.tableCellProduct]}>{item.description}</Text>
								<Text style={[styles.tableCell, styles.tableCellQuantity]}>{quantity}</Text>
								{canViewCostoBeneficio && (
									<>
										<Text style={[styles.tableCell, styles.tableCellCost]}>{convertPrice(purchase, null, true)}</Text>
										<Text style={[styles.tableCell, styles.tableCellBenefit]}>{convertPrice(benefit, null, true)}</Text>
									</>
								)}
								<Text style={[styles.tableCell, styles.tableCellPrice]}>{convertPrice(sale, null, true)}</Text>
							</View>
						);
					})}

					{/* Totals Row */}
					<View style={styles.tableRowTotal}>
						<Text style={[styles.totalCell, { flex: 5.9, textAlign: "right" }]}>TOTAL</Text>
						<Text style={[styles.totalCell, styles.tableCellQuantity]}>{totalQuantity}</Text>
						{canViewCostoBeneficio && (
							<>
								<Text style={[styles.totalCell, styles.tableCellCost]}>{convertPrice(totalCost)}</Text>
								<Text style={[styles.totalCell, styles.tableCellBenefit]}>{convertPrice(totalBenefit)}</Text>
							</>
						)}
						<Text style={[styles.totalCell, styles.tableCellPrice]}>{convertPrice(totalSale)}</Text>
					</View>
				</View>

				{/* Signatures */}
				<View style={styles.signatureContainer}>
					<View style={styles.signatureBox}>
						<Text style={styles.signatureLine}>___________________________</Text>
						<Text>{pdfData.cashier_name}</Text>
						<Text>Cajero</Text>
					</View>
					<View style={styles.signatureBox}>
						<Text style={styles.signatureLine}>___________________________</Text>
						<Text>{pdfData.manager_name}</Text>
						<Text>Gerente General</Text>
					</View>
				</View>
				<Text
					style={styles.pageNumbers}
					render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
					fixed
				/>
			</Page>
		</Document>
	);
};
